import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Table from 'views/betShopManagement/comissions/comissions/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the commissions view.
 * @extends JetView
 */
export default class comissionsView extends JetView {
    /**
     * Configures the layout of the commissions view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [], // Placeholder for future rows
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 1000, // Number of items per page
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            if (value == 1) {
                                // Excel export
                                var table = $$('treetable'); // Reference to the tree table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Comisiones'),
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('treetable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Comisiones'),
                                        autowidth: true, // Auto width for PDF
                                        ignore: { detailTittle: true }, // Ignore detail title in export
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            rows: [
                Table, // Including the Table component
            ],
        };
        const avanc = {
            view: 'accordion', // Accordion component for advanced details
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }], // Header and body for accordion
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Form view
            height: 'auto',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left column containing the Table
                },
            ],
        };
    }
}

// FILE DOCUMENTED
